import { Maybe, Scalars } from "@/@generated/graphql/types";

export interface EmployerAnnualSavingsContract {
  employerAnnualSavingsAmount?: Maybe<Scalars["Float"]["output"]>;
}

export const getEmployerAnnualSavingsAmount = (contract?: EmployerAnnualSavingsContract | null) =>
  contract?.employerAnnualSavingsAmount ?? undefined;
